module.exports = __webpack_public_path__ + "img/navy_blue.788d909.svg";